import React, { useState } from 'react';
import Styles from './my-portfolio-styles.scss';
import { ButtonKVBase, DefaultModal } from '@/presentation/components';
import { IconActivity } from '@/presentation/components/icons';
import colors from '../../styles/colors.scss';
import { useNavigate } from 'react-router';
import useValidateUserActivity from '@/presentation/hooks/use-validate-user-activity';
const MyPortfolio = ({ id }) => {
    const navigate = useNavigate();
    const { isAllowed, isLoading } = useValidateUserActivity('STOCK_TRADING');
    const [modalConfirm, setModalConfirm] = useState(false);
    const onGoStock = (e) => {
        setModalConfirm(false);
        navigate('/student-dashboard/activities/stock');
    };
    return (React.createElement("div", { className: Styles.content },
        React.createElement("div", { className: Styles.wrapper },
            React.createElement(ButtonKVBase, { onClick: () => setModalConfirm(true), type: "button", rightIcon: React.createElement(IconActivity, { color: "white" }), btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", disabled: isLoading || !isAllowed }, 'Start Trading'),
            React.createElement(DefaultModal, { height: "435", hUnit: "px", width: "512", wUnit: "px", open: modalConfirm, onClose: () => setModalConfirm(false), showClose: true, overlayCustomStyles: { zIndex: 9999 } },
                React.createElement("div", { className: Styles.modalContent },
                    React.createElement("div", { className: Styles.icon },
                        React.createElement(IconActivity, { color: colors.invitedText, style: { width: 64, height: 64 } })),
                    React.createElement("div", { className: Styles.title },
                        React.createElement("div", { className: Styles.main }, "It's time to trade!"),
                        React.createElement("div", { className: Styles.description }, 'Use what you have learned about the stock market to purchase your first three stocks.')),
                    React.createElement(ButtonKVBase, { onClick: onGoStock, type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)" }, 'Start'))))));
};
export default MyPortfolio;
